export const erWaitTimes = [
    {
      id: 1,
      hospitalName: "Mackenzie Health Richmond Hill Hospital",
      city: "Richmond Hill",
      address: "10 Trench St, Richmond Hill, ON",
      phone: "+1 905-883-1212",
      waitTimeMinutes: 95,
      patientsWaiting: 18,
      patientsBeingTreated: 11,
      patientsSeenToday: 163,
      patientsDischargedToday: 141,
      erDoctors: 4,
      nurses: 16,
      bedsAvailable: 7,
      ambulancesIncoming: 3,
      capacityPercent: 72,
      crowdLevel: "Moderate",
      status: "Open 24/7",
      distanceKm: 3.2,
      lastUpdated: "5 minutes ago",
      confidenceScore: 82,
      hasPediatricER: true,
      hasVirtualTriage: false,
      trend: [
        { time: "6 AM", wait: 45 },
        { time: "9 AM", wait: 70 },
        { time: "12 PM", wait: 95 },
        { time: "4 PM", wait: 130 },
        { time: "8 PM", wait: 90 }
      ],
      timeline: {
        registration: 15,
        triage: 25,
        waitingRoom: 55,
        doctorAssessment: 35
      }
    },
  
    {
      id: 2,
      hospitalName: "Toronto General Hospital",
      city: "Toronto",
      address: "200 Elizabeth St, Toronto, ON",
      phone: "+1 416-340-4800",
      waitTimeMinutes: 135,
      patientsWaiting: 32,
      patientsBeingTreated: 24,
      patientsSeenToday: 248,
      patientsDischargedToday: 219,
      erDoctors: 7,
      nurses: 28,
      bedsAvailable: 10,
      ambulancesIncoming: 5,
      capacityPercent: 84,
      crowdLevel: "Busy",
      status: "Open 24/7",
      distanceKm: 24.8,
      lastUpdated: "8 minutes ago",
      confidenceScore: 88,
      hasPediatricER: false,
      hasVirtualTriage: true,
      trend: [
        { time: "6 AM", wait: 60 },
        { time: "9 AM", wait: 95 },
        { time: "12 PM", wait: 135 },
        { time: "4 PM", wait: 170 },
        { time: "8 PM", wait: 120 }
      ],
      timeline: {
        registration: 20,
        triage: 30,
        waitingRoom: 85,
        doctorAssessment: 45
      }
    },
  
    {
      id: 3,
      hospitalName: "Sunnybrook Health Sciences Centre",
      city: "Toronto",
      address: "2075 Bayview Ave, Toronto, ON",
      phone: "+1 416-480-6100",
      waitTimeMinutes: 210,
      patientsWaiting: 47,
      patientsBeingTreated: 31,
      patientsSeenToday: 302,
      patientsDischargedToday: 261,
      erDoctors: 8,
      nurses: 34,
      bedsAvailable: 5,
      ambulancesIncoming: 6,
      capacityPercent: 91,
      crowdLevel: "Very Busy",
      status: "Open 24/7",
      distanceKm: 18.6,
      lastUpdated: "12 minutes ago",
      confidenceScore: 79,
      hasPediatricER: false,
      hasVirtualTriage: true,
      trend: [
        { time: "6 AM", wait: 75 },
        { time: "9 AM", wait: 140 },
        { time: "12 PM", wait: 210 },
        { time: "4 PM", wait: 250 },
        { time: "8 PM", wait: 190 }
      ],
      timeline: {
        registration: 25,
        triage: 40,
        waitingRoom: 145,
        doctorAssessment: 60
      }
    }
  ];